<template>
  <section>
    <slot></slot>

    <div class="choose-license__list">
      <!-- <plan-card
        class="choose-license__plan"
        plan-id="free"
        :show-price-area="true"
        :disabled="true"
      /> -->
      <plan-card
        v-for="planoption in selectedPlans"
        :key="planoption.id"
        class="choose-license__plan"
        :plan-id="planoption.id"
        :show-price-area="true"
        :users="users"
        @buy="selectPlan($event)"
        @update:users="emit('update:users', $event)"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";

import PlanCard from "@manager/plans/PlanCard.vue";
import type { LicensePlan } from "@manager/plans/plans.store";

interface Props {
  plans?: Record<
    string,
    { id: string; canAddSeats?: boolean; }
  >;
  users?: number;
}

const props = withDefaults(defineProps<Props>(), {
  plans: () => ({})
});

const emit = defineEmits<{
  (event: "select", plan: LicensePlan): void;
  (event: "update:users", users: number): void;
}>();

const selectedPlans = computed(() => {
  return Object.values(props.plans);
});

async function selectPlan(plan: LicensePlan) {
  emit("select", plan);
}
</script>

<style lang="scss">
.choose-license {
  &__list {
    display: grid;
    grid-template-columns: minmax(22rem, 1fr);
    justify-content: center;
    justify-items: center;
    gap: 1.5rem;
    padding: 1.5rem 0;

    @media screen and (min-width: 768px) {
      grid-template-columns: 26rem 26rem;
      gap: 3rem;
      padding: 3rem 0;
    }
  }

  &__errormessage {
    margin-top: 1.5rem;
    margin-bottom: 0;
  }

  &__select {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid var(--color-action);
    gap: 0.5rem;
    margin-top: 3rem;
    overflow: hidden;
    box-shadow: 0 8px 5px -5px var(--color-shadow-1);
  }
}
</style>
